import { render, staticRenderFns } from "./simpleComment.vue?vue&type=template&id=3ab16847&scoped=true"
import script from "./simpleComment.vue?vue&type=script&lang=js"
export * from "./simpleComment.vue?vue&type=script&lang=js"
import style0 from "./simpleComment.vue?vue&type=style&index=0&id=3ab16847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab16847",
  null
  
)

export default component.exports